import React, { useState } from 'react';
import { 
  Typography, 
  TextField, 
  Button, 
  Box,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { format, addHours, parse, differenceInMinutes } from 'date-fns';
import { WorkSettings } from '../types';

interface OffTimeCalculatorProps {
  settings: WorkSettings;
  onSettingsChange: (settings: WorkSettings) => void;
}

const OffTimeCalculator: React.FC<OffTimeCalculatorProps> = ({ settings, onSettingsChange }) => {
  const [startTime, setStartTime] = useState<string>('');
  const [isHalfDay, setIsHalfDay] = useState<boolean>(false);
  const [endTime, setEndTime] = useState<string>('');

  const calculateEndTime = () => {
    if (!startTime) return;

    const start = parse(startTime, 'HH:mm', new Date());
    const lunchStart = parse(settings.lunchBreakStart, 'HH:mm', new Date());
    const lunchEnd = parse(settings.lunchBreakEnd, 'HH:mm', new Date());

    let workHours = isHalfDay ? settings.minWorkHours / 2 : settings.minWorkHours;
    let end = addHours(start, workHours);

    if (start < lunchStart && end > lunchStart && !settings.includeLunchBreak) {
      const breakDuration = differenceInMinutes(lunchEnd, lunchStart) / 60;
      end = addHours(end, breakDuration);
    }

    setEndTime(format(end, 'HH:mm'));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <TextField
        fullWidth
        label="最少工作时间（小时）"
        type="number"
        value={settings.minWorkHours}
        onChange={(e) => onSettingsChange({ ...settings, minWorkHours: Number(e.target.value) })}
      />
      <TextField
        fullWidth
        label="午休开始时间"
        type="time"
        value={settings.lunchBreakStart}
        onChange={(e) => onSettingsChange({ ...settings, lunchBreakStart: e.target.value })}
      />
      <TextField
        fullWidth
        label="午休结束时间"
        type="time"
        value={settings.lunchBreakEnd}
        onChange={(e) => onSettingsChange({ ...settings, lunchBreakEnd: e.target.value })}
      />
      <TextField
        fullWidth
        label="上班时间"
        type="time"
        value={startTime}
        onChange={(e) => setStartTime(e.target.value)}
      />
      
      <FormControlLabel
        control={
          <Checkbox
            checked={isHalfDay}
            onChange={(e) => setIsHalfDay(e.target.checked)}
            color="primary"
          />
        }
        label="半天工作"
      />
      
      <Button
        fullWidth
        variant="contained"
        onClick={calculateEndTime}
        disabled={!startTime}
        sx={{ mt: 2 }}
      >
        计算下班时间
      </Button>

      {endTime && (
        <Box
          sx={{
            mt: 3,
            p: 2,
            bgcolor: 'primary.main',
            color: 'white',
            textAlign: 'center',
            borderRadius: '11px'
          }}
        >
          <Typography variant="h5">
            预计下班时间: {endTime}
          </Typography>
          {isHalfDay && (
            <Typography variant="body2" sx={{ mt: 1, opacity: 0.9 }}>
              （半天工作）
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default OffTimeCalculator;
